import { t } from 'i18next';
import { Cell } from 'react-table';

import { CellText, LinkText } from 'coreOld/elements';
import { formatDate } from 'coreOld/utils';
import { oldBomPartListPath } from 'jobs/routes';
import { IJob } from 'jobsOld/types';

export const columns = [
  {
    accessor: 'id',
    Header: () => <CellText mainText={t('labelJobId')} />,
    Cell: ({ row }: Cell<IJob>) => {
      const projectId = row.original.projectId;
      const jobId = row.original.id;

      return (
        <CellText
          mainText={<LinkText href={oldBomPartListPath(projectId, jobId)}>{jobId}</LinkText>}
        />
      );
    },
  },
  {
    accessor: 'jobName',
    Header: () => <CellText mainText={t('labelJobName')} />,
  },
  {
    accessor: 'disciplineName',
    Header: () => <CellText mainText={t('labelDiscipline')} />,
  },
  {
    accessor: 'supportUserName',
    Header: () => <CellText mainText={t('labelAssignedTo')} />,
  },
  {
    accessor: 'requesterUserName',
    Header: () => <CellText mainText={t('labelRequestedBy')} subTexts={[t('labelEmployeeId')]} />,
    Cell: ({ row }: Cell<IJob>) => {
      return (
        <CellText
          mainText={row.original.requesterUserName || '-'}
          subTexts={[row.original.requesterUserEmployeeId]}
        />
      );
    },
  },
  {
    accessor: 'requesterUserExternalRegion',
    Header: () => <CellText mainText={t('labelTheatre')} subTexts={[t('labelCountry')]} />,
    Cell: ({ row }: Cell<IJob>) => {
      return (
        <CellText
          mainText={row.original.externalLocationRegion || '-'}
          subTexts={[row.original.externalLocationCountry]}
        />
      );
    },
  },
  {
    accessor: 'status',
    Header: () => (
      <CellText mainText={t('labelStatus')} subTexts={[t('labelSupportRequestLevel')]} />
    ),
    Cell: ({ row }: Cell<IJob>) => {
      return (
        <CellText
          mainText={row.original.status || '-'}
          subTexts={[row.original.supportLevelName]}
        />
      );
    },
  },
  {
    accessor: 'requestedByDate',
    Header: () => (
      <CellText mainText={t('labelRequestedDate') || '-'} subTexts={[t('labelUpdatedAt')]} />
    ),
    Cell: ({ row }: Cell<IJob>) => {
      return (
        <CellText
          mainText={formatDate(row.original.requestedByDate) || '-'}
          subTexts={[formatDate(row.original.updatedAt)]}
        />
      );
    },
  },
];
